<template>
  <div class="button" :class="{ 'button--carousel': carouselBtn }">
    <div class="button__wrapper">
      <a class="button__cta"> <slot /> </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    buttonText: String,
    carouselBtn: {
      type: Boolean,
      default: false,
    },
    positionBtn: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.button {
  display: flex;
  justify-content: center;
}

.button--carousel {
  position: absolute;
  bottom: 5%;
  right: 10%;
}

.button__wrapper {
  background: linear-gradient(
    to right,
    var(--tertiary-color),
    var(--secondary-color),
    var(--tertiary-color)
  );
  border-radius: 50px;
  display: inline-block;
  padding: 4px;
  cursor: pointer;
}

.button__cta {
  font-family: "Seravek-Medium";
  font-size: 24px;
  line-height: 24px;
  color: var(--secondary-color);
  padding: 14px 37px;
  background-color: var(--primary-color);
  text-transform: uppercase;
  border-radius: 50px;
  display: inline-block;
  text-align: center;
}

.button__cta:hover,
.button__cta:focus {
  background-color: var(--primary-color-active);
  color: var(--secondary-color);
  transition: 0.5s ease;
}

/* Mobiles (Portrait) */
@media (min-width: 320px) and (max-width: 480px) {
  .button__cta {
    font-size: 18px;
    line-height: 1.1;
    padding: 12px 30px;
  }
  #section__carousel .button__cta {
    font-size: 10px;
    line-height: 1.1;
    padding: 6px 10px;
    border-radius: 40px;
  }
  #section__carousel .button__wrapper {
    border-radius: 40px;
    padding: 2px;
  }
}

/* Low Resolution Tablets, Mobiles (Landscape) */
@media (min-width: 481px) and (max-width: 767px) {
  .button__cta {
    font-size: 20px;
    line-height: 20px;
    padding: 10px 15px;
    border-radius: 40px;
  }
  #section__carousel .button__wrapper {
    border-radius: 40px;
    padding: 2px;
  }
}

/* Tablets, Ipads (portrait) */
@media (min-width: 768px) and (max-width: 1024px) {
  .button__cta{
    font-size: 22px;
    line-height: 24px;
    padding: 10px 15px;
  } 
  
}
</style>